import UrlPlugin from "@uppy/url";
import { PROXY_IMAGES } from "../../_actions/endpoints";

/**
 * The Import Url Media plugin
 */

class ImportUrlMedia extends UrlPlugin {
  static VERSION = "0.0.0";

  constructor(uppy, opts) {
    super(uppy, {
      companionUrl: "/",
      ...opts,
    });

    this.client = null;
    this.inProgress = false;
  }

  // eslint-disable-next-line class-methods-use-this
  getMeta(url) {
    return fetch(`${PROXY_IMAGES}${url}`)
      .then((res) => {
        if (!res.ok) {
          this.uppy.log("[ImportURLMedia] Fetch error");
          throw new Error("Failed to fetch the file");
        }
        return res;
      })
      .then((res) => res.blob());
  }

  addFile(fileUrl, fileName = "", isBase64 = false) {
    const url = isBase64 ? fileUrl : this.addProtocolToURL(fileUrl);
    const name = fileName || this.getFileNameFromUrl(url);

    if (!isBase64 && !this.checkIfCorrectURL(url)) {
      this.uppy.log(`[ImportURLMedia] Incorrect URL entered: ${url}`);
      this.uppy.info(this.i18n("enterCorrectUrl"), "error", 4000);
      return null;
    }

    // this.uppy.info(
    //   this.i18n("processingXFiles", { smart_count: 1 }),
    //   "info",
    //   4000
    // );

    return this.getMeta(url)
      .then((blob) => {
        const tagFile = {
          source: this.id,
          name,
          type: blob.type,
          data: blob,
        };
        return tagFile;
      })
      .then((tagFile) => {
        this.uppy.log("[ImportUrlMedia] Adding file");
        try {
          return this.uppy.addFile(tagFile);
        } catch (err) {
          if (!err.isRestriction) {
            this.uppy.log(err);
          }
          return err;
        }
      })
      .catch((err) => {
        this.uppy.log(err);
        this.uppy.info(
          {
            message: this.i18n("failedToFetch"),
            details: err,
          },
          "error",
          4000
        );
        return err;
      });
  }
}

export default ImportUrlMedia;
